import { CheckBoxOutlineBlank, DataUsage, DonutLarge, Public } from '@material-ui/icons'
import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import { getAccountId } from 'redux/actions/accountActions'

const DisplayCredits = ({ song, click, displayStyle, textStyle }) => {
    const { preview } = useSelector(state => state.playerControls)
    const { currentCredits, currentArtistCredits, currentPromotionalCredits } = useSelector(state => state.credits)
    const accountId = getAccountId()
    const semiTransparent = 'rgba(0, 0, 0, 0.05)'
    const displayStyles = {
        creditsStyle: {
            position: 'relative',
            fontSize: '2.5em',
            marginTop: '0.5em',
            borderRadius: '10px',
            backgroundColor: semiTransparent
        },
        creditsDisplayedStyle: {
            zIndex: 201, position: 'absolute', fontSize: '0.3em',
            fontVariant: currentCredits === 0 ? 'small-caps' : 'none',
            fontWeight: currentCredits === 0 ? 'bold' : 'normal',
            top: '0.6em',
            left: 0, color: 'white', width: '100%', textAlign: 'center',
            cursor: 'pointer'
        },
        artistCreditsDisplayedStyle: {
            zIndex: 201, position: 'absolute', fontSize: '0.3em',
            fontVariant: currentCredits === 0 ? 'small-caps' : 'none',
            fontWeight: currentCredits === 0 ? 'bold' : 'normal',
            top: '1.25em',
            left: 5, color: 'white', width: '100%', textAlign: 'center',
            cursor: 'pointer'
        }
    }
    const displayCredits = () => {
        const { accessType, userId } = song
        if (accessType !== ACCESS_TYPES.PUBLIC) {
            const useArtistCredits = accountId === userId && currentArtistCredits > 0
            const usePromotionalCredits = currentPromotionalCredits > 0
            const actualCredits = preview ? 0
                : usePromotionalCredits ? currentPromotionalCredits
                    : useArtistCredits ? currentArtistCredits
                        : currentCredits
            const creditsDisplayed = actualCredits === 0 ? 'Pr'
                : Intl.NumberFormat({ maximumFractionDigits: 0, useGrouping: false }).format(actualCredits)
            return (
                <div
                    onClick={(evt) => {
                        evt.stopPropagation()
                        click()
                    }}
                    style={{ ...displayStyles.creditsStyle, ...displayStyle }}>

                    {usePromotionalCredits ?
                        <CheckBoxOutlineBlank
                            style={{
                                fontSize: '1em',
                                backgroundColor: semiTransparent,
                                cursor: 'pointer',
                                color: actualCredits <= 5 ? 'red' : 'green'
                            }} /> :
                        useArtistCredits ?
                            <DonutLarge
                                style={{
                                    fontSize: '1em',
                                    backgroundColor: semiTransparent,
                                    cursor: 'pointer',
                                    color: actualCredits <= 5 ? 'red' : 'green'
                                }} />
                            : <DataUsage
                                style={{ color: actualCredits === 0 ? 'blue' : actualCredits <= 5 ? 'red' : 'gold' }} />}
                    <span
                        title='Credits'
                        style={{
                            ...displayStyles.creditsDisplayedStyle,
                            ...textStyle
                        }}>{creditsDisplayed}</span>
                </div>
            )
        } else {
            return (
                <div
                    style={{ ...displayStyles.creditsStyle, ...displayStyle }}>
                    <Public
                        style={{
                            fontSize: '1em',
                            backgroundColor: semiTransparent,
                            color: 'aqua'
                        }}
                    />
                </div>
            )
        }
    }

    return displayCredits()
}

export default memo(DisplayCredits)